import { lazyWithRetry } from "@/router/lazyWithRetry";
import { RouteConfig } from "@/router/types";

const VerifierLayout = lazyWithRetry(
  () => import("@/components/layouts/VerifierLayout"),
);
const WorkQueue = lazyWithRetry(() => import("@/pages/verifier/WorkQueue"));

const FullDataReport = lazyWithRetry(() => import("@/pages/verifier/reports"));
const Notifications = lazyWithRetry(
  () => import("@/pages/verifier/notifications"),
);
const MyAccount = lazyWithRetry(() => import("@/pages/myAccount"));
const BatchDetailsVerifier = lazyWithRetry(
  () => import("@/pages/batchIngestion/details"),
);
const VerifierBatchIngestion = lazyWithRetry(
  () => import("@/pages/batchIngestion"),
);
const DocumentVerification = lazyWithRetry(
  () => import("@/pages/verifier/documentVerification"),
);

const VerifierRoutes: RouteConfig[] = [
  {
    path: "/verifier",
    layout: VerifierLayout,
    allowNonAdmin: true,
    children: [
      { path: "dashboard", component: WorkQueue },
      { path: "work-queue", component: WorkQueue },
      { path: "batch-ingestion", component: VerifierBatchIngestion },
      { path: "batch-ingestion/:batchId", component: BatchDetailsVerifier },
      { path: "document-verification/:id?", component: DocumentVerification },
      { path: "reports", component: FullDataReport },
      { path: "notifications", component: Notifications },
      { path: "account", component: MyAccount },
      { path: "", index: true, redirectTo: "/verifier/dashboard" },
    ],
  },
];

export default VerifierRoutes;
